import classnames from 'clsx';
import { useIntl } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { testId } from 'ui-components/services/testid-service';

import { useSortedTranslatedCountries } from '../../../../hooks/use-sorted-translated-countries';
import countryNameMessages from '../../../country-names.messages';
import messages from '../messages';
import commonStyle from '../common-style.module.less';

type CountryDropdownProps = {
  onChange: (countryCode: string) => void;
  selectedCountryCode?: string;
  pickerClassName?: string;
};

type TranslatedCountry = {
  code: string;
  label: string;
};

export const CountryDropdown = ({ onChange, selectedCountryCode = '', pickerClassName = '' }: CountryDropdownProps) => {
  const intl = useIntl();
  const countries = useSortedTranslatedCountries() as TranslatedCountry[];

  const dropdownTextMessage =
    countryNameMessages[selectedCountryCode as keyof typeof countryNameMessages] || messages.countryOfOriginDefault;

  return (
    <DropdownMenu
      {...testId('customs-widget-country-dropdown')}
      className={commonStyle['standard-dropdown']}
      dropdownMenuShouldHaveWidthOfButton
      fullWidth
      value={selectedCountryCode}
      variant='form'
    >
      <DropdownMenuToggler className={classnames(commonStyle['standard-dropdown'], pickerClassName)}>
        {intl.formatMessage(dropdownTextMessage)}
      </DropdownMenuToggler>
      {countries.map(({ code, label }) => (
        <DropdownMenuItem key={code} onClick={() => onChange(code)} selected={selectedCountryCode === code}>
          {label}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};
